import { render } from "./termsReport.vue?vue&type=template&id=5c7953cd&scoped=true"
import script from "./termsReport.vue?vue&type=script&lang=js"
export * from "./termsReport.vue?vue&type=script&lang=js"

import "./termsReport.vue?vue&type=style&index=0&id=5c7953cd&scoped=true&lang=css"

import exportComponent from "C:\\Users\\USER\\Desktop\\중요\\tcd-cube_opr\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5c7953cd"]])

export default __exports__